import React, { PureComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Table } from "reactstrap";
import PrintHeader from "../../../common/component/PrintHeader";
import { showCurrency, showQty } from "../../../common/function/showValueHelper";
import SafeBig from "../../../common/function/safeBig";

type InjectedProps = {
    data: any;
    companyInfo: any;
    colSpan: number;
};

class Standard extends PureComponent<WithTranslation & InjectedProps> {
    render() {
        const { t, data, companyInfo, colSpan } = this.props;
        if (data == null) return <p>No Data</p>;
        let columns = data.detailList.map((obj: any, index: number) => {
            return (
                <tr key={"detail-" + index}>
                    <td className="rowNo">{index + 1}</td>
                    <td>{obj.productName ?? obj.product.name}</td>
                    <td className="qty">
                        {obj.unitConversion === null ? (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " "}</td>
                                        <td>{obj.product?.unit?.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " " + obj.unit?.name}</td>
                                        <td>@{ showQty(obj.unitConversion) + " " + obj.product?.unit?.name } </td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </td>
                    {colSpan === 5 ? (<td className="price">{showCurrency(SafeBig(obj.price).div(obj.unitConversion).toString(), 2)}</td>) : ""}
                    <td className="price">{showCurrency(obj.price, 2)}</td>
                    <td className="disc">{showCurrency(obj.disc1, 2)}</td>
                    <td className="subTotal">{showCurrency(obj.subtotal, 2)}</td>
                </tr>
            );
        });

        let badanUsaha = companyInfo.find((val: any) => {
            return val.key === "status-badan-usaha";
        });

        return (
            <Table className="ra-table-print">
                <PrintHeader
                    title={t("common.sales")}
                    companyInfo={companyInfo}
                    customer={data.customer}
                    no={data.key}
                    dtCreated={data.dtCreated}
                />
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            <Table className="ra-table-detail-print">
                                <thead>
                                    <tr>
                                        <th className="rowNo">#</th>
                                        <th>{t("common.product")}</th>
                                        <th className="qty">{t("common.qty")}</th>
                                        { colSpan === 5 ? (<th className="price">{t("common.price@")}</th>) : ""}
                                        <th className="price">{t("common.price")}</th>
                                        <th className="disc">{t("common.discount")}</th>
                                        <th className="subtotal">{t("common.subTotal")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {columns}
                                    <tr>
                                        <td colSpan={colSpan}>
                                            <b>{t("common.calculatedPrice")}: </b> <br /> {data.say} {" "} Rupiah
                                        </td>
                                        <td style={{ textAlign: "right" }}>{t("common.discount")}</td>
                                        <td className="summaryTable">{showCurrency(data.disc2AmountTotal)}</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={5} colSpan={colSpan}>
                                            {t("common.notes")}: {data.description}
                                        </td>
                                    </tr>
                                    {badanUsaha === "PKP" ? (
                                        <tr>
                                            <td style={{ textAlign: "right" }}>{t("common.taxBase")}</td>
                                            <td className="summaryTable">{showCurrency(data.subtotal, 2)}</td>
                                        </tr>
                                    ) : null}
                                    {badanUsaha === "PKP" ? (
                                        <tr>
                                            <td style={{ textAlign: "right" }}>{t("common.tax")}</td>
                                            <td className="summaryTable">{showCurrency(data.vat, 2)}</td>
                                        </tr>
                                    ) : null}
                                    {data.dpUsage ? (
                                        <tr>
                                            <td style={{ textAlign: "right" }}>{t("common.downPayment")}</td>
                                            <td className="summaryTable">{showCurrency(data.dpUsage, 2)}</td>
                                        </tr>
                                    ) : null}
                                    <tr>
                                        <td style={{ textAlign: "right" }}>{t("common.grandTotal")}</td>
                                        <td className="summaryTable">{showCurrency(data.grandTotal, 2)}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}

export default withTranslation()(Standard);
